import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { SystemOverview } from './components/SystemOverview';
import { PackContents } from './components/PackContents';
import { BonusSection } from './components/BonusSection';
import { QualificationSection } from './components/QualificationSection';
import { ResultsSection } from './components/ResultsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-terracotta selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SystemOverview data-id="element-3" />
      <PackContents data-id="element-4" />
      <BonusSection data-id="element-5" />
      <QualificationSection data-id="element-6" />
      <ResultsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}